import { createReducer, on } from '@ngrx/store';

import { DEFAULT_RESOURCE_PAGE } from '../constants';
import { Resource, RESOURCE_PAGE_ACTIONS } from '@data-access/resource';

export const RESOURCE_REDUCER = createReducer(
  DEFAULT_RESOURCE_PAGE,
  on(RESOURCE_PAGE_ACTIONS.onLoadResourceSuccess, (state, { resource }) => {
    const _resource = resource.reduce((acc: Resource[], r) => {
      if (!acc.some((rr) => rr.label.toLowerCase() === r.label.toLowerCase())) {
        acc.push(r);
      }
      return acc;
    }, []);

    return {
      ...state,
      resources: [..._resource],
    };
  }),
);
